export const COLORS = {
  light: 'text-white',
  black: 'text-black',
  slate50: 'text-slate-50',
} as const;

type ObjectValues<T> = T[keyof T];
export type ColorType = ObjectValues<typeof COLORS>;
